import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import { AuthProvider } from "@/contexts/AuthContext";
import { LocaleProvider } from "@/contexts/LocaleContext";
import { AuthGateProvider } from "@/contexts/AuthGateContext";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import MobileBottomNav from "@/components/layout/MobileBottomNav";
import ProtectedRoute from "@/components/ProtectedRoute";

import Home from "@/pages/Home";
import Properties from "@/pages/Properties";
import PropertyDetail from "@/pages/PropertyDetail";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import AuthCallback from "@/pages/AuthCallback";
import Favorites from "@/pages/Favorites";
import Dashboard from "@/pages/Dashboard";
import PropertyForm from "@/pages/PropertyForm";
import Messages from "@/pages/Messages";
import Projects from "@/pages/Projects";
import ProjectDetail from "@/pages/ProjectDetail";
import ProjectForm from "@/pages/ProjectForm";
import NotFound from "@/pages/NotFound";
import News from "@/pages/News";
import NewsDetail from "@/pages/NewsDetail";
import AdminNews from "@/pages/AdminNews";
import Account from "@/pages/Account";

function AppShell() {
  const location = useLocation();
  // Handle OAuth session_id in URL fragment before any routing
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <>
      <Navbar />
      <main className="min-h-[60vh] with-bottom-nav">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/properties" element={<Properties />} />
          <Route path="/properties/:id" element={<PropertyDetail />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/projects/:id" element={<ProjectDetail />} />
          <Route path="/noticias" element={<News />} />
          <Route path="/noticias/:slug" element={<NewsDetail />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/auth/callback" element={<AuthCallback />} />
          <Route
            path="/favorites"
            element={
              <ProtectedRoute>
                <Favorites />
              </ProtectedRoute>
            }
          />
          <Route
            path="/messages"
            element={
              <ProtectedRoute>
                <Messages />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute role="agente">
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard/new"
            element={
              <ProtectedRoute role="agente">
                <PropertyForm />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard/edit/:id"
            element={
              <ProtectedRoute role="agente">
                <PropertyForm />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard/projects/new"
            element={
              <ProtectedRoute role="agente">
                <ProjectForm />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard/projects/edit/:id"
            element={
              <ProtectedRoute role="agente">
                <ProjectForm />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/news"
            element={
              <ProtectedRoute role="admin">
                <AdminNews />
              </ProtectedRoute>
            }
          />
          <Route
            path="/cuenta"
            element={
              <ProtectedRoute>
                <Account />
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
      <MobileBottomNav />
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <LocaleProvider>
        <AuthProvider>
          <AuthGateProvider>
            <AppShell />
            <Toaster position="top-right" richColors closeButton />
          </AuthGateProvider>
        </AuthProvider>
      </LocaleProvider>
    </BrowserRouter>
  );
}
